export const tenantLanguageMap: Record<string, string> = {
  English: "en",
  Español: "es",
  Spanish: "es",
  Français: "fr",
  French: "fr",
  Deutsch: "de",
  German: "de",
  Türkçe: "tr",
  Turkish: "tr",
  en: "en",
  es: "es",
  fr: "fr",
  de: "de",
  tr: "tr",
};

export function normalizeLanguageCode(value: string | null | undefined): string {
  if (!value) return "en";
  return tenantLanguageMap[value] ?? "en";
}

export function getCookieValue(name: string): string | null {
  if (typeof document === "undefined") return null;

  const value = document.cookie
    .split("; ")
    .find((item) => item.startsWith(`${name}=`))
    ?.split("=")[1];

  return value ? decodeURIComponent(value) : null;
}

export function getStoredAppLanguage(): string | null {
  if (typeof window === "undefined") return null;

  const storedLanguage = localStorage.getItem("app-storage");
  if (!storedLanguage) return null;

  try {
    const parsed = JSON.parse(storedLanguage);
    if (!parsed.state?.languageManuallySelected) {
      return null;
    }

    return parsed.state?.language ?? null;
  } catch {
    return null;
  }
}

export function getInitialLanguage(): string {
  const storedLanguage = getStoredAppLanguage();
  if (storedLanguage) {
    return storedLanguage;
  }

  return normalizeLanguageCode(getCookieValue("tenant_default_language"));
}
